import { Chip, Grid, Stack, Tooltip, Typography } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import * as React from 'react';
import * as Redux from 'react-redux';
import styled from 'styled-components';
import * as CONST from '../../../../../constants/FieldsConst';
import { formatHoraHorarioHelper, textLabels } from '../../../../../helpers';
import { useNotification } from '../../../../../helpers/Notification';
import { LoadingWidget } from '../../../../../widgets';
import ActionsListWidget from '../../../../../widgets/ActionsList';
import DeleteModalComponent from '../../../../../widgets/modals/DeleteModal';
import { NameComponent } from '../../../../usuario/usuarios/components/ListadoUsuarios';
import {
  allEntHorBloquesAction,
  deleteEntHorBloquesAction,
  setActivoEntHorBloquesAction,
} from '../EntHorBloquesAction';
import { PARAMS_ENTHOR_BLOQUES } from '../EntHorBloquesReducer';

export const Links = styled.a`
  cursor: pointer;
  color: black;
  margin: 0px 0px;
  text-decoration: none;

  &:hover {
    color: blue;
  }
`;

const ListadoEntHorBloques = ({ isDelete = false, setIsDelete = () => {} }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const entHorBloquesStore = Redux.useSelector((state) => state.entHorBloques);
  const entHorariosClasesStore = Redux.useSelector(
    (state) => state.entHorariosClases,
  );

  const [loadingDelete, setLoadingDelete] = React.useState(false);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);
  const [rows, setRows] = React.useState([]);

  React.useEffect(() => {
    const fetchData = async () => {
      const payload = {
        ...entHorBloquesStore.params,
        idEntHorarioClase: entHorariosClasesStore.activo.id,
      };
      dispatch({ type: PARAMS_ENTHOR_BLOQUES, payload });
      if (entHorBloquesStore.all && entHorBloquesStore.all.length === 0) {
        await allEntHorBloquesAction(dispatch, payload);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const rowsData = [];
    entHorBloquesStore.all.forEach((el) => {
      rowsData.push({
        ...el,
        nombre: {
          nombre: el.nombre,
          break: el.break,
        },
      });
    });
    setRows(rowsData);
  }, [entHorBloquesStore.all]);

  const _handleEditClick = async (id) => {
    setIsDelete(false);
    const data = entHorBloquesStore.all.find((el) => el.id === id);
    await setActivoEntHorBloquesAction(dispatch, data);
    // setOpenModalForm(true);
  };

  const _onDeleteHandler = async (id) => {
    setLoadingDelete(true);
    await deleteEntHorBloquesAction(
      { dispatch, notify },
      entHorBloquesStore.activo.id,
      entHorBloquesStore.params,
    );
    setLoadingDelete(false);
    setOpenModalDelete(false);
  };

  const columns = [
    {
      name: CONST.ID,
      options: {
        display: loginStore.isRoot ? false : 'excluded',
        filter: false,
      },
    },
    {
      name: CONST.nombre.name,
      label: CONST.nombre.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack direction="row" alignItems="center">
              <NameComponent
                onClick={() => _handleEditClick(tableMeta.rowData[0])}
                mr="10px"
              >
                {value.nombre}
              </NameComponent>
              {value.break && (
                <Tooltip describeChild title="Tiempo libre" placement="top">
                  <Chip label="Libre" size="small" color="success" />
                </Tooltip>
              )}
              {entHorBloquesStore.activo?.id === tableMeta.rowData[0] &&
                !isDelete && (
                  <Chip
                    label="Editando"
                    size="small"
                    color="info"
                    sx={{ mr: 1 }}
                  />
                )}
            </Stack>
          );
        },
      },
    },
    {
      name: CONST.abrev.name,
      label: CONST.abrev.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.num.name,
      label: CONST.num.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    // {
    //   name: CONST.breaking.name,
    //   label: CONST.breaking.label,
    //   options: {
    //     filter: true,
    //     sort: true,
    //     customBodyRender: (value, tableMeta, updateValue) => {
    //       return value ? 'SI' : 'NO';
    //     },
    //   },
    // },
    {
      name: CONST.turno.name,
      label: CONST.turno.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value === 0 ? 'MAÑANA' : 'TARDE';
        },
      },
    },
    {
      name: CONST.start.name,
      label: CONST.start.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return formatHoraHorarioHelper(value);
        },
      },
    },
    {
      name: CONST.end.name,
      label: CONST.end.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return formatHoraHorarioHelper(value);
        },
      },
    },
    // {
    //   name: CONST.estatus.name,
    //   label: CONST.estatus.label,
    //   options: {
    //     filter: true,
    //     sort: true,
    //     customBodyRender: (value, tableMeta, updateValue) => {
    //       return (
    //         <Tooltip
    //           describeChild
    //           title="Estatus del registro"
    //           placement="left"
    //         >
    //           <Chip
    //             label={value.nombre}
    //             size="small"
    //             color={value.id === 1 ? 'success' : 'error'}
    //           />
    //         </Tooltip>
    //       );
    //     },
    //   },
    // },
    {
      name: CONST.actions.name,
      label: CONST.actions.label,
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack direction="row">
              <ActionsListWidget
                id={tableMeta.rowData[0]}
                onEdit={() => _handleEditClick(tableMeta.rowData[0])}
                onDelete={async () => {
                  setIsDelete(true);
                  const data = entHorBloquesStore.all.find(
                    (el) => el.id === tableMeta.rowData[0],
                  );
                  await setActivoEntHorBloquesAction(dispatch, data);
                  setOpenModalDelete(true);
                }}
              />
            </Stack>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    reponsive: 'scroll',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },
    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    print: false,
    download: false,
    textLabels,
    selectableRowsHideCheckboxes: true,
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      return <Grid container></Grid>;
    },
  };

  return (
    <Grid container sx={{ mt: 1 }}>
      <Grid item md={12}>
        <LoadingWidget
          isLoading={entHorBloquesStore.loadingAll || loadingDelete}
        />
        <MUIDataTable
          title={'Listado'}
          data={rows}
          columns={columns}
          options={options}
        />
      </Grid>
      {entHorBloquesStore.activo && (
        <DeleteModalComponent
          open={openModalDelete}
          onClose={() => setOpenModalDelete(!openModalDelete)}
          onDelete={_onDeleteHandler}
        >
          <Typography variant="h6">
            {entHorBloquesStore.activo.nombre}
          </Typography>
        </DeleteModalComponent>
      )}
    </Grid>
  );
};

export default ListadoEntHorBloques;
